var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaAbajoHover24X24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2928 13.9512C12.1243 14.0957 11.8757 14.0957 11.7071 13.9512L5.48808 8.62062C5.17359 8.35105 4.70011 8.38747 4.43055 8.70197C4.16098 9.01646 4.1974 9.48994 4.51189 9.7595L10.7309 15.0901C11.4612 15.7161 12.5388 15.7161 13.269 15.0901L19.4881 9.75951C19.8026 9.48994 19.839 9.01646 19.5694 8.70197C19.2999 8.38747 18.8264 8.35105 18.5119 8.62062L12.2928 13.9512Z",
    fill: "#212831"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaAbajoHover24X24);
export default __webpack_public_path__ + "static/media/FLECHA_ABAJO_HOVER_24X24.2be0a325240676f7cfb4c2109a419eb9.svg";
export { ForwardRef as ReactComponent };